// Releasit kapıda ödeme butonu ve formu: uygulamanın İngilizce yazılarını Türkçeye çevirir.
// Sadece tam eşleşen metinler değişir; yazar uygulamada kendi metnini girerse ona dokunulmaz.
(function () {
  var WORDS = {
    'Buy with Cash on Delivery': 'Kapıda Ödeme ile Satın Al',
    'Subtotal': 'Ara toplam',
    'Shipping': 'Kargo',
    'Free': 'Ücretsiz',
    'Discounts': 'İndirim',
    'Discount': 'İndirim',
    'Total': 'Toplam',
    'Shipping method': 'Kargo',
    'Free shipping': 'Ücretsiz kargo',
    'Enter your shipping address': 'Teslimat bilgilerin',
    'First name': 'Ad',
    'Last name': 'Soyad',
    'Phone': 'Telefon',
    'Address': 'Açık adres',
    'Civic number / Address 2': 'Bina ve daire no',
    'Province': 'İl',
    'City': 'İlçe',
    'Zip code': 'Posta kodu',
    'Email': 'E-posta',
    'This field is required': 'Bu alan zorunlu',
    'This field is required.': 'Bu alan zorunlu',
    'Required': 'Zorunlu',
    'Invalid phone number': 'Telefon numarası geçersiz',
    'Invalid email': 'E-posta geçersiz',
    'Subscribe to our newsletter': 'Kampanyalardan haberdar et'
  };
  // Kutu içi örnek yazılar: etiketi tekrar etmek yerine yol gösterir
  var HINTS = { phone: '05XX XXX XX XX', address: 'Mahalle, sokak, kapı no', civic_number: 'Örn. No 5 Daire 3', first_name: '', last_name: '', province: 'Örn. İstanbul', city: 'Örn. Kadıköy', zip_code: 'Örn. 34000', email: 'ornek@mail.com' };
  var ROOTS = '#rsi_form_wrapper, #rsi_buy_now_button';

  function fix(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) {
      var node = walker.currentNode;
      var text = node.nodeValue.trim();
      if (text && Object.prototype.hasOwnProperty.call(WORDS, text)) node.nodeValue = WORDS[text];
    }
    root.querySelectorAll('[placeholder]').forEach(function (el) {
      if (Object.prototype.hasOwnProperty.call(HINTS, el.name)) {
        if (el.getAttribute('placeholder') !== HINTS[el.name]) el.setAttribute('placeholder', HINTS[el.name]);
        return;
      }
      var ph = el.getAttribute('placeholder').trim();
      if (Object.prototype.hasOwnProperty.call(WORDS, ph)) el.setAttribute('placeholder', WORDS[ph]);
    });
  }

  var queued = false;
  function run() {
    queued = false;
    document.querySelectorAll(ROOTS).forEach(fix);
  }
  function queue() {
    if (queued) return;
    queued = true;
    // Sekme arka plandayken de çalışsın diye requestAnimationFrame değil
    setTimeout(run, 30);
  }
  new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  queue();
})();
